import axios from 'axios';
import router from '../router';
// import store from "@/store";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});

//request interceptor
service.interceptors.request.use(
  (config) => {
    // 不传递默认开启loading
    // if (!config.hideloading) {
    //   // loading
    //   Toast.loading({
    //     message: "加载中...",
    //     forbidClick: true,
    //     loadingType: "spinner"
    //   });
    // }
    config.headers['Content-type'] = 'application/json;charset=UTF-8';
    // if (getToken() !== '' && getToken() !== null && getToken() !== undefined) {
    //   config.headers['token'] = getToken();
    //   config.headers['userId'] = getUid();
    // }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    //console.log("response--->",response);
    if (response.status === 200) {
      return res;
    } else {
      return res;
    }
  },
  (error) => {
    const data = error.response.data;
    if (!error.response) {
      console.log('断网了，请检查网络状态后重试');
    }
    if (error && error.stack.indexOf('timeout') > -1) {
      console.log('请求超时');
    }

    // let result = judgeChinese(data.responseMsg);
    // if (result == true) {
    //   toastError(data.responseMsg);
    // } else {
    //   toastError('系统错误');
    // }
    return Promise.reject(error);
  }
);

function toastError(msg) {
  if (msg.length > 0) {
    console.log('错误信息：' + msg);
  } else {
    console.log('操作失败，稍后再试吧~');
  }
}

export default service;
